<template>
  <navbar :agentLanding="true">

  </navbar>
</template>

<script>
import Navbar from '@/components/common/Navbar'
export default {
  name:"home-view",
  components:{
    Navbar
  },

  mounted() {

  },

  data(){
    return{

    }

  }
}
</script>
